<template>
    <v-layout row v-if="errorAlert.state" class="alert-wrapper mt-2 mb-2">
        <v-flex sm12>
            <v-alert v-model="errorAlert.state" align-center justify-center type="error">
            <v-layout wrap align-center>
                <v-flex
                xs10
                >
                {{ errorAlert.message }}
                </v-flex>
                <v-flex
                xs2
                >
                <v-layout wrap align-center justify-end>
                    <v-btn small text icon class="mpl-4" color="ffffff" @click="clearAlertError">
                    <v-icon>close</v-icon>
                </v-btn>
                </v-layout>
                </v-flex>
            </v-layout>
            </v-alert>
        </v-flex>
    </v-layout>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

export default {
  name: 'AlertError',
  components: {
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters({
      errorAlert: 'global/getAlertError',
    }),
  },
  methods: {
    ...mapMutations({
      clearAlertError: 'global/clearAlertError',
    }),
  },
};
</script>

<style lang="scss" scoped>
</style>
